// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from './index.vue'
import New from '../.components/new.vue'
import Edit from '../.components/edit.vue'

const main_router = 'materials'
const new_router = 'new_material'
const edit_router = 'edit_material'

const router = [
    {
        path: '',
        component: Index,
        name: 'materials',
        meta: {
            api_name: 'api_v1_provider_materials',
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_material',
        meta: {
            api_name: 'api_v1_provider_materials_create',
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: ':material_identity/edit',
        component: Edit,
        name: 'edit_material',
        meta: {
            api_name: 'api_v1_provider_material_update',
            breadcrumb: [main_router, edit_router]
        }
    },
]

export default router
